import Work1 from '../../assets/work1.png';
import Work2 from '../../assets/work2.png';
import Work3 from '../../assets/work3.png';
import Work4 from '../../assets/work4.png';
import Work5 from '../../assets/work5.png';
import Work6 from '../../assets/work6.png';
import Work7 from '../../assets/work7.png';
import Work8 from '../../assets/work8.png';
import Work9 from '../../assets/work9.png';
import Work10 from '../../assets/work10.png';
import Work11 from '../../assets/work11.png';
import Work12 from '../../assets/work12.png';

export const projectData = [
	{
		id: 1,
		image: Work1,
		title: 'E-Commerce Website Backend',
		category: 'Backend',
		link: 'https://github.com/vipinsaini21/E-Commerce-Website-Backend',
	},
	{
		id: 2,
		image: Work2,
		title: 'Social Media App Backend',
		category: 'Backend',
		link: 'https://github.com/vipinsaini21/Social-Media-App-Backend',
	},
	{
		id: 3,
		image: Work3,
		title: 'Smart Store',
		category: 'Full Stack',
		link: 'https://github.com/vipinsaini21/Smart-Store',
	},
	{
		id: 4,
		image: Work4,
		title: 'Portfolio',
		category: 'Full Stack',
		link: 'https://github.com/vipinsaini21/My-Portfolio',
	},
	{
		id: 5,
		image: Work5,
		title: 'Streamify - Youtube Clone',
		category: 'Frontend',
		link: 'https://github.com/vipinsaini21/Streamify',
	},
	{
		id: 6,
		image: Work6,
		title: 'Weather App',
		category: 'Basic JS',
		link: 'https://github.com/vipinsaini21/Basic-Js-Projects/tree/main/Weather%20App',
	},
	{
		id: 7,
		image: Work7,
		title: 'Counter Timer',
		category: 'Basic JS',
		link: 'https://github.com/vipinsaini21/Basic-Js-Projects/tree/main/Counter%20Timer',
	},
	{
		id: 8,
		image: Work8,
		title: 'Daily Goals',
		category: 'Basic JS',
		link: 'https://github.com/vipinsaini21/Basic-Js-Projects/tree/main/Daily%20Goals',
	},
	{
		id: 9,
		image: Work9,
		title: 'Name Tag',
		category: 'Basic JS',
		link: 'https://github.com/vipinsaini21/Basic-Js-Projects/tree/main/Name%20Tag',
	},
	{
		id: 10,
		image: Work10,
		title: 'Para Generator',
		category: 'Basic JS',
		link: 'https://github.com/vipinsaini21/Basic-Js-Projects/tree/main/Para%20Generator',
	},
	{
		id: 11,
		image: Work11,
		title: 'Stop Watch',
		category: 'Basic JS',
		link: 'https://github.com/vipinsaini21/Basic-Js-Projects/tree/main/StopWatch',
	},
	{
		id: 12,
		image: Work12,
		title: 'Your Lucky Color',
		category: 'Basic JS',
		link: 'https://github.com/vipinsaini21/Basic-Js-Projects/tree/main/Your%20Lucky%20Color',
	},
];

export const projectsNav = [
	{
		name: 'Full Stack',
	},
	{
		name: 'Frontend',
	},
	{
		name: 'Backend',
	},
	{
		name: 'Basic JS',
	},
];
